/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'company': {
    width: 24,
    height: 24,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M512 810.667h85.333V256l272.811 116.907A42.667 42.667 0 01896 412.16v398.507h85.333V896H42.667v-85.333H128v-569.6a42.667 42.667 0 0125.344-38.998L482.005 55.98A21.333 21.333 0 01512 75.52v735.147z"/>'
  }
})
